module.exports = __webpack_public_path__ + "static/media/order3.9d95313b.png";